import { useEffect, useState } from "react";
import { toast } from "sonner";
import { getPosts, createPost, approvePost, getClients } from "./opsApi";
import { useOpsAuth } from "./OpsAuthContext";
import { Plus, CheckCircle2 } from "lucide-react";

const inp = "w-full rounded-lg border border-white/10 bg-white/5 px-3 py-2 text-sm text-white outline-none focus:border-[#AC3333]";
const PLATFORMS = ["Instagram", "TikTok", "YouTube", "Facebook", "X (Twitter)"];
const badge = { borrador: "bg-slate-500/20 text-slate-300", scheduled: "bg-emerald-500/20 text-emerald-300" };

export default function OpsPosts() {
  const { user } = useOpsAuth();
  const isSuper = user?.role === "super_admin";
  const [rows, setRows] = useState([]);
  const [clients, setClients] = useState([]);
  const [f, setF] = useState({ client_id: "", platform: PLATFORMS[0], text: "", media_url: "", scheduled_at: "" });

  const load = () => { getPosts().then(setRows).catch(() => {}); getClients().then(setClients).catch(() => {}); };
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!f.client_id || !f.text.trim() || !f.scheduled_at) { toast.error("Cliente, texto y fecha requeridos"); return; }
    try {
      const iso = new Date(f.scheduled_at).toISOString();
      await createPost({ ...f, scheduled_at: iso }); setF({ ...f, text: "", media_url: "", scheduled_at: "" }); load();
      toast.success("Borrador guardado (requiere aprobación del Super Admin)");
    } catch (e) { toast.error(e?.response?.data?.detail || "Error"); }
  };
  const cname = (id) => clients.find((c) => c.id === id)?.name || "—";

  return (
    <div data-testid="ops-posts">
      <h2 className="mb-5 font-serif text-2xl font-bold text-white">Publicaciones</h2>
      <p className="mb-4 text-xs text-white/40">El panel solo guarda el contenido. La publicación la ejecuta n8n cuando el Super Admin aprueba y llega la fecha.</p>
      <div className="mb-6 grid gap-3 rounded-2xl border border-white/10 bg-[#241010] p-5 sm:grid-cols-2">
        <div><label className="mb-1 block text-xs text-white/50">Cliente</label>
          <select data-testid="ops-post-client" value={f.client_id} onChange={(e) => setF({ ...f, client_id: e.target.value })} className={inp}><option value="">—</option>{clients.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}</select></div>
        <div><label className="mb-1 block text-xs text-white/50">Red</label>
          <select data-testid="ops-post-platform" value={f.platform} onChange={(e) => setF({ ...f, platform: e.target.value })} className={inp}>{PLATFORMS.map((p) => <option key={p}>{p}</option>)}</select></div>
        <div className="sm:col-span-2"><label className="mb-1 block text-xs text-white/50">Texto</label>
          <textarea data-testid="ops-post-text" rows={3} value={f.text} onChange={(e) => setF({ ...f, text: e.target.value })} className={`${inp} resize-none`} /></div>
        <div><label className="mb-1 block text-xs text-white/50">URL de media (opcional)</label><input data-testid="ops-post-media" value={f.media_url} onChange={(e) => setF({ ...f, media_url: e.target.value })} className={inp} /></div>
        <div><label className="mb-1 block text-xs text-white/50">Programar para</label><input data-testid="ops-post-date" type="datetime-local" value={f.scheduled_at} onChange={(e) => setF({ ...f, scheduled_at: e.target.value })} className={inp} /></div>
        <div className="sm:col-span-2"><button data-testid="ops-post-add" onClick={add} className="flex items-center gap-1.5 rounded-lg bg-[#AC3333] px-4 py-2 text-sm font-semibold text-white hover:bg-[#FF0505]"><Plus className="h-4 w-4" /> Guardar borrador</button></div>
      </div>
      <div className="space-y-2">
        {rows.map((p) => (
          <div key={p.id} data-testid={`ops-post-${p.id}`} className="rounded-xl border border-white/10 bg-[#241010] p-3">
            <div className="flex flex-wrap items-center gap-3">
              <span className={`rounded-full px-2 py-0.5 text-[11px] ${badge[p.status] || badge.borrador}`}>{p.status === "scheduled" ? "programado" : "borrador"}</span>
              <span className="text-xs text-white/40">{cname(p.client_id)} · {p.platform} · {p.scheduled_at ? new Date(p.scheduled_at).toLocaleString() : "sin fecha"}</span>
              {isSuper && p.status !== "scheduled" && <button data-testid={`ops-post-approve-${p.id}`} onClick={() => approvePost(p.id).then(load)} className="ml-auto flex items-center gap-1 rounded-lg bg-emerald-600 px-3 py-1 text-xs font-semibold text-white hover:bg-emerald-500"><CheckCircle2 className="h-3.5 w-3.5" /> Aprobar y programar</button>}
            </div>
            <p className="mt-2 text-sm text-white/80">{p.text}</p>
          </div>
        ))}
        {rows.length === 0 && <p className="text-sm text-white/40">Sin publicaciones.</p>}
      </div>
    </div>
  );
}
